<bpt-empty-feedback-results [status]="noResultStatus" [title]="noResultMessage"
      [displayButtons]="noResultDisplayButtons" [subTitle]="noResultSubTitle">
</bpt-empty-feedback-results>

